import buildTitleUrl from './buildTitleUrl';

export type TitleListingType = 'movies' | 'tv';

export default function buildListingTitleUrl({
  listingType,
  locale,
  shortId,
  slugs
}: {
  listingType: TitleListingType;
  locale: string;
  shortId: string;
  slugs?: {
    slug: string;
    iso_3166_1: string;
  }[];
}) {
  return buildTitleUrl({
    type: listingType === 'movies' ? 'movie' : 'tv',
    locale,
    shortId,
    slugs
  });
}
